import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'coral' | 'white';
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  variant = 'coral',
  href = '#offer'
}: CTAButtonProps) {
  const colors = variant === 'coral' ? 'bg-brand-coral text-white hover:bg-brand-coralDark focus-visible:ring-brand-coral' : 'bg-white text-brand-navy hover:bg-brand-main focus-visible:ring-white';
  return <a href={href} className={`cta-attention inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-sm font-extrabold uppercase tracking-wide shadow-md transition-[background-color,box-shadow] duration-200 ease-out hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 md:text-base ${colors} ${className}`} data-id="element-34" data-mp="2p11ixh0ny4zi">
      {children}
      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-35" data-mp="38p20k5tk3hqz" />
    </a>;
}